// Components/WebSitePolicy.js
import React from 'react';
import './WebSitePolicy.css';

const WebSitePolicy = () => {
  return (
    <div className="policy-container">
     
      <section>
        <h2>Terms and Conditions</h2>
        <p>
          This website is Designed, Developed and Maintained for Food and Consumer Protection Department, Government of Bihar. These terms and conditions shall be governed by and construed in accordance with the Indian Laws. Any dispute arising under these terms and conditions shall be subject to the jurisdiction of the courts of India. The information posted on this website could include hypertext links or pointers to information created and maintained by non-Government/private organisations. Food and Consumer Protection Department, Government of Bihar is providing these links and pointers solely for your information and convenience. When you select a link to an outside website, you are leaving the 'Guidelines for Government of Bihar Websites' site and are subject to the privacy and security policies of the owners/sponsors of the outside website.
        </p>

      </section>

      <section>
        <h2>Privacy Policy</h2>
        <p>
          We do not collect personal information for any purpose other than to respond to you (for example, to respond to your queries). If you choose to provide us with personal information like filling out a Contact Us form with an e-mail address or postal address, and submitting it to us through the website, we use that information to respond to your message, and to help you get the information you have requested. Our website never collects information or creates individual profiles for commercial marketing. While you must provide an e-mail address for a localised response to any incoming questions or comments to us, we recommend that you do NOT include any other personal information.
        </p>

      </section>

      <section>
        <h2>Hyperlinking Policy</h2>
        <p>
          We do not object to you linking directly to the information that is hosted on our site and no prior permission is required for the same. However, we would like you to inform us about any links provided to our site so that you can be informed of any changes or updations therein. Also, we do not permit our pages to be loaded into frames on your site. Our website's pages must load into a newly opened browser window of the user.
        </p>

      </section>

      <section>
        <h2>Copyright Policy</h2>
        <p>
          Contents of this website may not be reproduced partially or fully, without due permission from Food and Consumer Protection Department, Government of Bihar. If referred to as a part of another website, the source must be appropriately acknowledged. The contents of this website cannot be used in any misleading or objectionable context.

        </p>
      </section>
    </div>
  );
};

export default WebSitePolicy;
